import HierarchyKPIDetails from './HierarchyKPIDetails'
export default HierarchyKPIDetails
